import { Typography, Grid } from "@material-ui/core";
import React from "react";
import compose from "recompose/compose";
import { withStyles } from "@material-ui/core/styles";
import StarsSharpIcon from "@material-ui/icons/StarsSharp";
import HorizontalLineGraph from "./../../../common/HorizontalLineGraph";
import Properties from "../../../../properties/Properties";

const styles = (theme) => ({
  totalDetails: {
    color: "#a52a2a",
    fontWeight: "bold",
    fontSize: "20px",
    display: "flex",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexWrap: "nowrap",
      height: "20%",
      justifyContent: "flex-start",
      margin: "0",
    },
  },
  totalDetails1: {
    color: "#a52a2a",
    fontWeight: "bold",
    fontSize: "20px",
    display: "flex",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexWrap: "nowrap",
      height: "20%",
      justifyContent: "flex-start",
      margin: "0",
    },
  },
  totalDetails2: {
    color: "#a52a2a",
    fontWeight: "bold",
    fontSize: "20px",
    display: "flex",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexWrap: "nowrap",
      height: "20%",
      justifyContent: "flex-start",
      margin: "0",
      marginLeft: "5%",
    },
  },
  totalDetailsRunner: {
    color: "#a52a2a",
    fontWeight: "bold",
    fontSize: "20px",
    display: "flex",
    width: "100%",
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexWrap: "nowrap",
      height: "20%",
      justifyContent: "flex-start",
      margin: "0",
    },
  },
  totalDetailsRunner1: {
    color: "#a52a2a",
    fontWeight: "bold",
    fontSize: "20px",
    display: "flex",
    width: "100%",
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexWrap: "nowrap",
      height: "20%",
      justifyContent: "flex-start",
      margin: "0",
      marginLeft: "10%",
    },
  },
  runnerActivityStyling: {
    color: "#a52a2a",
    fontWeight: "bold",
    fontSize: "20px",
    display: "flex",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexWrap: "nowrap",
      height: "20%",
      margin: "0",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  totalDetailsWell: {
    color: "#a52a2a",
    fontWeight: "bold",
    fontSize: "20px",
    display: "flex",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexWrap: "nowrap",
      textAlign: "left",
      margin: "0",
    },
  },
  graph1: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "flex-start",
      marginTop: "0",
    },
  },
  nestedGrid: {
    [theme.breakpoints.up("sm")]: {
      gridColumn: "span 6",
    },
    [theme.breakpoints.up("xs")]: {
      gridColumn: "span 6",
    },
    [theme.breakpoints.up("md")]: {
      gridColumn: "span 8",
    },
    [theme.breakpoints.down("xs")]: {
      gridColumn: "span 12",
    },
  },
  rankStyling: {
    marginLeft: "0%",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "10%",
    },
  },
});

function FamilyGroup(props) {
  const { classes, familyValues, navigateToWellnessPointsDetails } = props;

  return (
    <Grid
      container
      style={{
        width: "100%",
        display: "flex",
        height: "90%",
      }}
    >
      {/* Summary Header */}
      {familyValues?.showTable && (
        <>
          {/* Family Group Name */}
          {familyValues?.familyGroupName && (
            <Grid item xs={4} sm={3} lg={4} md={4}>
              <Typography variant="body2">
                <span className={classes.totalDetailsRunner}>
                  <span
                    style={{
                      color: "#727272",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    {Properties.Label_FamilyGroup}
                  </span>
                </span>

                <div>
                  <span className={classes.totalDetailsRunner}>
                    {familyValues?.familyGroupName}
                  </span>
                </div>
              </Typography>
            </Grid>
          )}

          {/* X-Axis Label + Total */}
          <Grid item xs={4} sm={3} lg={4} md={4}>
            <Typography variant="body2">
              {/* Label */}
              <span className={classes.totalDetailsRunner1}>
                {familyValues?.familyGraphRunnerActivities?.length > 0 &&
                  (familyValues?.totalFamilyDistance > 0 ||
                    familyValues?.totalFamilySteps > 0 ||
                    familyValues?.totalFamilyWellnessPoints > 0) && (
                    <span
                      style={{
                        color: "#727272",
                        fontWeight: "bold",
                        fontSize: "18px",
                      }}
                    >
                      {familyValues?.familyGraphXAxis === "steps"
                        ? Properties.Label_Steps
                        : familyValues?.familyGraphXAxis === "wellnessPoint"
                        ? Properties.Label_WellnessPoints
                        : familyValues?.familyGraphXAxis === "distance"
                        ? Properties.Distance_label
                        : ""}
                    </span>
                  )}
              </span>

              {/* Total values */}
              {familyValues?.familyGraphRunnerActivities?.length > 0 &&
                (familyValues?.totalFamilyDistance > 0 ||
                  familyValues?.totalFamilySteps > 0 ||
                  familyValues?.totalFamilyWellnessPoints > 0) && (
                  <div>
                    <span className={classes.totalDetails2}>
                      {familyValues?.familyGraphXAxis === "steps"
                        ? familyValues?.totalFamilySteps
                        : familyValues?.familyGraphXAxis === "wellnessPoint"
                        ? familyValues?.totalFamilyWellnessPoints
                        : familyValues?.familyGraphXAxis === "distance"
                        ? `${(familyValues?.totalFamilyDistance / 1000).toFixed(
                            2
                          )} Km`
                        : ""}
                    </span>
                  </div>
                )}
            </Typography>
          </Grid>

          {/* Rank */}
          <Grid item xs={4} sm={3} lg={4} md={4}>
            <Typography variant="body2">
              <span className={classes.totalDetailsRunner}>
                {(familyValues?.totalFamilyDistance > 0 ||
                  familyValues?.totalFamilySteps > 0 ||
                  familyValues?.totalFamilyWellnessPoints > 0) && (
                  <span
                    style={{
                      color: "#727272",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                   {Properties.Label_ResultRank}
                  </span>
                )}
              </span>

              <div>
                <span className={classes.totalDetails}>
                  {familyValues?.familyGroupRank || "---"}
                </span>
              </div>
            </Typography>
          </Grid>
        </>
      )}

      {/* Graph */}
      {familyValues?.showGraph &&
        familyValues?.showTable &&
        (familyValues?.totalFamilyDistance > 0 ||
          familyValues?.totalFamilySteps > 0 ||
          familyValues?.totalFamilyWellnessPoints > 0) && (
          <Grid item className={classes.graph1}>
            <Grid item xs={12} lg={8} md={8} className={classes.nestedGrid}>
              <div key="horizontals">
                <HorizontalLineGraph
                  teamSteps={familyValues?.totalFamilySteps}
                  teamWellness={familyValues?.totalFamilyWellnessPoints}
                  teamDistance={familyValues?.totalFamilyDistance}
                  graphData={familyValues?.familyGraphRunnerActivities}
                  graphXAxis={familyValues?.familyGraphXAxis}
                  graphYAxis={familyValues?.familyGraphYAxis || ""}
                />
              </div>
            </Grid>
          </Grid>
        )}
    </Grid>
  );
}

export default compose(withStyles(styles, { withTheme: true }))(FamilyGroup);
